import { orchestrator } from 'satcheljs';
import { getGoDaddyDomainDetails } from '../services/getGoDaddyDomainDetails';
import { getPremiumLegacyTenant } from '../services/getPremiumLegacyTenant';
import setGoDaddyDomainDetails from '../mutators/setGoDaddyDomainDetails';
import setPremiumLegacyTenant from '../mutators/setPremiumLegacyTenant';
import { getGoDaddyDomainDetails as getGoDaddyDomainDetailsAction } from '../actions/getGoDaddyDomainDetails';
import getPremiumUser from './getPremiumUser';
import store from '../store/store';
import { getWhoIsDomainDetails } from '../services/getWhoisDomainDetails';
import setTransferDomain from '../mutators/setTransferDomain';

export default orchestrator(
    getGoDaddyDomainDetailsAction,
    async function getGoDaddyDomainDetailsAction() {
        getPremiumUser(null);
        if (store.legacyPremiumTenant.TenantName == '') {
            let legacyPremiumTenantResponse = await getPremiumLegacyTenant();
            setPremiumLegacyTenant(legacyPremiumTenantResponse);
            if (store.legacyPremiumTenant.TenantName != null) {
                let response = await getWhoIsDomainDetails();
                if (response.raw.search('http://www.wildwestdomains.com') == -1) {
                    setTransferDomain(true);
                } else {
                    setTransferDomain(false);
                }
            }
        }
        let response = await getGoDaddyDomainDetails(store.legacyPremiumTenant.TenantName);
        setGoDaddyDomainDetails(response);
    }
);
